const IN_APP_BROWSER_UA_PATTERN =
  /(fbav|fban|instagram|line\/|micromessenger|snapchat|tiktok|twitter|wv\)|; wv)/i;
const ANDROID_UA_PATTERN = /android/i;
const IOS_UA_PATTERN = /iphone|ipad|ipod/i;
const FACEBOOK_UA_PATTERN = /fbav|fban|fb_iab/i;
const INSTAGRAM_UA_PATTERN = /instagram/i;

export function resolveUserAgent(userAgent = null) {
  return (
    userAgent ??
    (typeof window === "undefined" ? "" : window.navigator?.userAgent || "")
  );
}

export function isInAppBrowser(userAgent = null) {
  return IN_APP_BROWSER_UA_PATTERN.test(String(resolveUserAgent(userAgent)));
}

export function isAndroidUserAgent(userAgent = null) {
  return ANDROID_UA_PATTERN.test(String(resolveUserAgent(userAgent)));
}

export function isIosUserAgent(userAgent = null) {
  return IOS_UA_PATTERN.test(String(resolveUserAgent(userAgent)));
}

export function isFacebookInAppBrowser(userAgent = null) {
  return FACEBOOK_UA_PATTERN.test(String(resolveUserAgent(userAgent)));
}

export function isInstagramInAppBrowser(userAgent = null) {
  return INSTAGRAM_UA_PATTERN.test(String(resolveUserAgent(userAgent)));
}

/**
 * Utilise pour les heuristiques de viewport (seuils clavier, etc.), jamais
 * pour neutraliser globalement les safe areas : iOS garde toujours besoin de
 * safe-area-inset-bottom pour l'indicateur d'accueil.
 */
export function detectInAppBrowserEnvironment(userAgent = null) {
  const resolvedUserAgent = resolveUserAgent(userAgent);
  const isAndroid = isAndroidUserAgent(resolvedUserAgent);
  const isIos = isIosUserAgent(resolvedUserAgent);
  const isFacebook = isFacebookInAppBrowser(resolvedUserAgent);
  const isInstagram = isInstagramInAppBrowser(resolvedUserAgent);

  return {
    isInAppBrowser: isInAppBrowser(resolvedUserAgent),
    isAndroid,
    isIos,
    isFacebook,
    isInstagram,
  };
}

export const IN_APP_BROWSER_AUTH_NOTICE = Object.freeze({
  title: "Ouvre Karango dans ton navigateur",
  message:
    "Pour te connecter et participer, ouvre d'abord cette sortie dans ton navigateur. Dans le menu ... de l'application, choisis \"Ouvrir dans le navigateur\".",
});
